var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unHasViolation"},[_c('div',{staticClass:"con"},[_c('span',{staticClass:"iconfont",class:_vm.iconfontName}),_c('div',{staticClass:"tip"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.tipText)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }